import nessaPic from "@/public/images/artists/nessa.png";
import { Artist } from "@/types/types";

export const nessa = {
  id: "176",
  name: "Nessa",
  image: nessaPic,
  description: `Nessa's vocal delivery is characterized by a sultry, enchanting quality that effortlessly blends elements of R&B, neo-soul, and Afro-pop. With a naturally warm resonance and understated power, her vocals maintain a magnetic focus, drawing attention to their melodic texture.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fnessa-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["RnB", "Soul", "Unprocessed", "Belting"],
      secondary: ["Neo soul"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 59,
        high: 72,
      },
      sweetSpot: 64,
    },
  },
} as const satisfies Artist;
